import InfoIconCard from "components/icons/IconInfoCard"
import Tooltip from "components/Tooltip"
import BodyText from "components/Typography/BodyText"
import Caption, { CaptionProps } from "components/Typography/Caption"
import { ReactNode, memo, useMemo } from "react"
import styled from "styled-components"
import { formatPrice } from "utils/formatPrice"

const InfoCardContainer = styled.div`
  background: ${(props) => props.theme.palette.white};
  border-radius: 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  box-shadow: 0px 3px 8px 0px #0000000d;
  padding: 12px 20px;
  gap: 8px;
  width: 100%;
  position: relative;
`

const TextInfoCard = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
`

const IconWrapper = styled.div`
  display: flex;
  justify-content: start;
  align-items: center;
`

const DescriptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`

interface InfoCardProps {
  icon: ReactNode
  value: string | number
  description: string
  tooltipText: string
  isPrice?: boolean
  descriptionColor?: CaptionProps["color"]
}

const InfoCard = (props: InfoCardProps) => {
  const { icon, value, description, isPrice, tooltipText, descriptionColor = "gray-dark" } = props

  const formatResult = useMemo(() => {
    const totalValue = value

    if (isPrice) return formatPrice(Number(totalValue), "BRL")

    return totalValue
  }, [value, isPrice])

  return (
    <InfoCardContainer>
      <TextInfoCard>
        <IconWrapper>{icon}</IconWrapper>
        <DescriptionContainer>
          <BodyText size="large" color="gray-dark" weight="bold">
            {formatResult}
          </BodyText>
          <Caption color={descriptionColor} weight="semi-bold" size="medium">
            {description}
          </Caption>
        </DescriptionContainer>
      </TextInfoCard>
      <Tooltip
        text={tooltipText}
        toolTipClassName="position-absolute align-right"
        hoverClassName="positon-unset fit-content"
      >
        <InfoIconCard />
      </Tooltip>
    </InfoCardContainer>
  )
}

export default memo(InfoCard)
